import Loader from "@amzn/meridian/esm/components/loader";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import WaveformLayout from "./WaveformLayout";

/**
 * RtmsRestartLoading - Loading view shown when restarting from the error modal.
 */
const RtmsRestartLoading = () => {
  return (
    <WaveformLayout icon={<Loader size="medium" />}/>
  );
};

export default RtmsRestartLoading;
